import { isDate, isNotNullUndefinedOrEmptyString, isNumber, objectGetValueWithNestedKey } from '@/features/shared/tools'
import { isAdherentOuMandatGestion } from './tools'
import type { SourceNirDTO } from '@/features/api/extranet/dto/Demande/shared'
import { PropertyStatus } from '@/features/domaine/property-status'
import type { NestedKeyOf } from '@/features/shared/types'

/* Communes */
export const preNotNullOrEmpty = isNotNullUndefinedOrEmptyString
export const preDateValide = isDate
export const preEquals =
  (...args: any[]) =>
  (value: any) =>
    args.includes(value)
export const preNotEquals =
  (...args: any[]) =>
  (value: any) =>
    !args.includes(value)
export const preNombreValide = isNumber
export const preAdherentOuMandatGestion = isAdherentOuMandatGestion
export const preEstNirPortail = (_value: any, parent: SourceNirDTO) => parent?.source === 'Portail'

export function preStatusBuilder<TModel extends object, TContext extends object>(...statusValides: PropertyStatus[]) {
  return function preEstPresent(path: NestedKeyOf<TModel>) {
    return function (_value: any, _parent: any, _model: any, context: TContext) {
      const statutPath = `status.${path}.$status` as NestedKeyOf<TContext>
      const statusItem: PropertyStatus =
        objectGetValueWithNestedKey(context, statutPath) ?? PropertyStatus.Optional
      return statusValides.includes(statusItem)
    }
  }
}
/*
export function preEstPresentBuilder<TModel extends object, TContext extends object>() {
  return function preEstPresent(path: NestedKeyOf<TModel>) {
    return function (_value: any, _parent: any, _model: any, context: TContext) {
      const statutPath = `status.${path}.$status` as NestedKeyOf<TContext>
      const status: PropertyStatus | undefined = objectGetValueWithNestedKey(context, statutPath)
      return status !== PropertyStatus.NotPresent
    }
  }
}

export function preEstObligatoireBuilder<TModel extends object, TContext extends object>() {
  return function preEstObligatoire(path: NestedKeyOf<TModel>) {
    return function (_value: any, _parent: any, _model: any, context: TContext) {
      const statutPath = `status.${path}.$status` as NestedKeyOf<TContext>
      const status: PropertyStatus | undefined = objectGetValueWithNestedKey(context, statutPath)
      return status === PropertyStatus.Required
    }
  }
}
*/
